export default __webpack_public_path__ + "static/andrew@2x-eaeaad1c7b082719aa5ec16747132bde.jpg";